import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    // minHeight: 'calc(100vh - 64px)', // Assuming header height is 64px
    padding: 20,
    backgroundColor: 'background.paper',
    height: 'calc(100vh - 135px)',
  },
  contentWrapper: {
    backgroundColor: '#F5F5F5', // Light gray background
    padding: '24px',
    width: '100%',
    borderRadius: '4px',
    marginTop: '0px',
  },
  content: {
    textAlign: 'center',
    maxWidth: '600px',
    margin: '0 auto',
  },
  message: {
    color: 'text.primary',
    marginBottom: 30,
    fontSize: '16px',
    lineHeight: 1.5,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px', // Space between message and button
  },
  button: {
    backgroundColor: 'region.main',
    color: 'common.white',
    '&:hover': {
      backgroundColor: 'region.dark',
    },
    padding: '8px 24px',
    marginTop: 20,
    borderRadius: '16px',
    textTransform: 'none',
    minWidth: '160px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: 20,
    color: 'text.primary',
  },
}));

const ErrorPage = ({ handleReturnToHome }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.contentWrapper}>
        <Box className={classes.content}>
          <Typography className={classes.title}>Error Page</Typography>
          <Typography className={classes.message}>
            It looks like the link has expired. Please click the button below to
            restart the session.
          </Typography>
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          onClick={handleReturnToHome}
          className={classes.button}
          disableRipple
          data-testid="return-home-button"
        >
          Return to home
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage;
